import React from 'react';
import {FaLayerGroup} from 'react-icons/fa';
import {GoHomeFill} from 'react-icons/go';
import {PiUsersFill} from 'react-icons/pi';
import {BiSolidBookBookmark} from "react-icons/bi";
import {FaHandsPraying, FaHandHoldingDollar } from "react-icons/fa6";
import {GiMusicalNotes} from "react-icons/gi";

export const SidebarData = [
  {
    title: 'Fandraisana',
    path: '/',
    icon: <GoHomeFill />,
  },
  {
    title: 'Fanohanana',
    path: '/don',
    icon: <FaHandHoldingDollar />,
  },
  {
    title: 'Teny zaraina',
    path: '/tenyzaraina',
    icon: <BiSolidBookBookmark />,
  },
  {
    title: 'Foto-kevitra',
    path: '/theme',
    icon: <FaLayerGroup />,
  },
  {
    title: 'Vavaka',
    path: '/vavaka',
    icon: <FaHandsPraying />,
  },
  {
    title: 'Hira',
    path: '/hira',
    icon: <GiMusicalNotes />,
  },
  {
    title: 'Mpampiasa',
    path: '/user',
    icon: <PiUsersFill />,
  },
];
